import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncLoanBudget = loadable(() => import('./LoanBudget'), {
  fallback: <Loader />,
});
